module.exports = __webpack_public_path__ + "static/img/fgbg1-3.6eeee42.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-3.png
// module id = 181
// module chunks = 0